import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { AddButton } from 'components/_basic/Form/FieldArray/components/AddButton';
import { RemoveButton } from 'components/_basic/Form/FieldArray/components/RemoveButton';
import { ProductVolumeIn } from 'components/BusinessToolForm/components/ProductVolumeIn';

import { SalesProductsItem } from './SalesProductsItem';
import { ISalesPlanProductsProps } from './types';

import styles from './SalesPlanProducts.module.scss';

const MAX_LENGTH = 5;

export const SalesPlanProducts: React.FC<ISalesPlanProductsProps> = ({
  name,
  fields,
  disabled,
  onAddRow,
  onRemoveRow,
}) => {
  const { t } = useTranslation();

  const canAddMore = fields.length < MAX_LENGTH;
  const canRemove = fields.length > 1;

  return (
    <>
      <Box>
        {fields.map((item, index) => {
          const productName = `${name}.${index}`;
          return (
            <Box key={item.id} className={styles.rowContainer}>
              <Box className={styles.rowChildren}>
                <ProductVolumeIn productName={productName} disabled={disabled} />
                <SalesProductsItem name={productName} disabled={disabled} />
              </Box>
              <RemoveButton canRemove={canRemove} disabled={disabled} onClick={() => onRemoveRow(index)} />
            </Box>
          );
        })}
      </Box>
      <AddButton canAddMore={canAddMore} onClick={onAddRow} disabled={disabled} variant="text">
        {t('global.products.buttonText')}
      </AddButton>
    </>
  );
};
